import { z } from 'zod/v4';

import { columns } from './columns';

export const visualVendorSchema = z.object(columns);

export type VisualVendor = z.output<typeof visualVendorSchema>;

export const visualVendorSelect = [
  'id',
  'name',
] as const satisfies readonly (keyof VisualVendor)[];

export type VisualVendorQueryRecord = Pick<
  VisualVendor,
  (typeof visualVendorSelect)[number]
>;

export const visualConfiguratorVendorSchema = z.object({
  id: z.string().transform((s) => s.toUpperCase()),
  name: z.string().nullable(),
}) satisfies z.ZodType<VisualVendorQueryRecord>;

export type VisualConfiguratorVendor = z.output<
  typeof visualConfiguratorVendorSchema
>;
